import React from "react";
import "./shipping-delivery.css";

export default function ShippingDelivery() {
  return (
    <div className="shipping-page">
      <section className="shipping-hero">
        <div className="shipping-hero-inner">
          <span className="shipping-eyebrow">Shipping & Delivery</span>
          <h1>Coming Soon</h1>
          <p>We’re preparing our shipping details. Please check back soon.</p>
        </div>
      </section>
    </div>
  );
}
